import {List, Map} from "immutable";

export default {
  search_vessels: [],
  search_users: [],
  voyage_history: [], // 航海記録情報を保持
  my_vessel_positions: List(), // 自船の船舶情報を時系列で保持
  my_vessel_position_all: List(),
  my_vessel_position_indexes: List(),
  my_vessel_wake_all: List(),
  my_vessel_wake: List(), // 自船の航跡
  vessel_positions: List(), // 他船の船舶情報を時系列で保持
  before_vessel_positions: Map(), // 計算用に一つ前の船舶データを保持
  movement_vessels: Map(), // マップに表示汁船舶を管理
  backup_index: { // 再生用のCacheIndexを保持
    wake: 0,
    my_pos: 0,
    other_pos: 0
  },
  vessels: Map(), // 船舶情報を保持
  // MapBoxのステータス保持
  isReady: false,
  loaded_layers: List(),
  map_info: {
    center: {lat: null, lon: null},
    south_west: null,
    north_east: null
  },
  // Create js tick
  tick: false,
  fps: 1,
  start_time: 0,
  end_time: 0,
  current_time: 0,
  base_index: 0,
  max_index: 0,
  gc_time: 0,
  gc_interval: 300,
  chunk_size: 1000,
  is_pause: true,
  voyageHistorySummary: {
    users: List(),
    vessels: List()
  },
  voyageHistoryUserLogs: List(),
  voyageHistoryVesselLogs: List(),
  project: {
    enterpriseId: ""
  },
  histories: {},
  history: {
    currentTime: null, // APIから取得した最初の時刻を設定,
    previousTime: null, // 前回再生時間
    isReverse: false,
    playSpeed: 1,
    playVessels: [],
    wakes: [],
    isPause: false
  },
  playHistoryId: "",
  deleteHistoryId: "",
  step: null,
  enterpriseVoyageHistories: [],
  pageable: null,
  change_slider: false
};
